export default function register() {

}

// function registerValidSW(swUrl) {
//
// }
//
// function checkValidServiceWorker(swUrl) {
//
// }

export function unregister() {

}
